import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { Box, Typography } from '@mui/material';

const ColumnChartBillingHistoryDash = ({ color, title, labelColor, data, categoryName }) => {
  try {
    const rawData = Array.isArray(data) ? data : [];

    const totalData = rawData.map((item) => item.total || 0);

    const option = {
      title: {
        text: title,
        textStyle: {
          fontSize: '14px'
        }
      },
      legend: {
        data: [categoryName],
        right: '0',
      },
      yAxis: [
        {
          type: 'value',
        },
        {
          axisLabel: {
            formatter: '',
          },
        },
      ],
      xAxis: {
        type: 'category',
        data: rawData.map((item) => (item.dia !== undefined ? `Dia ${item.dia}` : item.mes)),
      },
      series: [
        {
          data: totalData,
          type: 'bar',
          stack: 'a',
          name: categoryName,
          itemStyle: {
            borderRadius: [10, 10, 10, 10],
            color: color,
          },
          label: {
            show: true,
            formatter: (params: {value: number}) => Math.round(params.value),
            position: 'top',
            backgroundColor: labelColor,
            padding: [5, 10],
            borderRadius: [5],
          },
        },
      ],
    } as ChartOption;

    return (
      <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'}>
        <Chart option={option} />
      </Box>
    );
  } catch (error) {
    console.error('Erro ao renderizar o gráfico:', error);
    return <Typography color="error">Erro ao carregar os dados do gráfico.</Typography>;
  }
};

export default ColumnChartBillingHistoryDash;
